import { ExpandMoreRounded } from '@mui/icons-material';
import { Popover, SxProps, Theme, Typography, styled } from '@mui/material';
import { useState } from 'react';
import { DateTimeRange } from '@cnx-saas/common';
import { DateTimeRangePopoverContent } from './DateTimeRangePopoverContent';

export type DateTimeRangePopoverButtonProps = {
  value: DateTimeRange;
  onChange: (value: DateTimeRange) => void;
  label: string;
  sx?: SxProps<Theme>;
  showTime?: boolean;
};

export function DateTimeRangePopoverButton({
  label,
  sx,
  value,
  showTime,
  onChange,
}: DateTimeRangePopoverButtonProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  return (
    <>
      <Button onClick={(e) => setAnchorEl(e.currentTarget)} sx={sx}>
        <Typography variant="body1" noWrap>
          {label}
        </Typography>
        <ExpandMoreRounded sx={{ color: 'text.secondary' }} />
      </Button>
      {
        <Popover
          open={!!anchorEl}
          onClose={() => {
            setAnchorEl(null);
          }}
          anchorEl={anchorEl}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <DateTimeRangePopoverContent
            onChange={onChange}
            value={value}
            showTime={showTime}
            sx={{ width: '238px' }}
          />
        </Popover>
      }
    </>
  );
}

const Button = styled('button')(({ theme }) => ({
  height: 40,
  width: 180,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0 8px 0 16px',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: 'transparent',
}));
